import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { Breadcrumb } from '../components/common/Breadcrumb';
import { BackofficeFilters } from '../components/backoffice/BackofficeFilters';
import { BackofficeTable } from '../components/backoffice/BackofficeTable';
import { BackofficeModal } from '../components/backoffice/BackofficeModal';
const breadcrumbItems = [{
  label: 'Configuración',
  href: '#'
}, {
  label: 'Gestión de Usuarios BackOffice'
}];
export const BackofficeUsers = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const handleEdit = user => {
    setEditingUser(user);
    setIsModalOpen(true);
  };
  const handleClose = () => {
    setIsModalOpen(false);
    setEditingUser(null);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-1343">
      <main className="pt-16 pl-64" data-id="element-1344">
        <div className="max-w-7xl mx-auto p-8" data-id="element-1345">
          <div className="mb-8" data-id="element-1346">
            <Breadcrumb items={breadcrumbItems} data-id="element-1347" />
            <div className="flex justify-between items-center mt-4" data-id="element-1348">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-1349">
                Gestión de Usuarios BackOffice y Brigadas
              </h1>
              <button onClick={() => setIsModalOpen(true)} className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-1350">
                <PlusIcon className="h-5 w-5 mr-2" data-id="element-1351" />
                Nuevo Usuario
              </button>
            </div>
          </div>
          <BackofficeFilters data-id="element-1352" />
          <BackofficeTable onEdit={handleEdit} data-id="element-1353" />
          <BackofficeModal isOpen={isModalOpen} onClose={handleClose} user={editingUser} data-id="element-1354" />
        </div>
      </main>
    </div>;
};